// Auto-generated type file
import { Address } from '../data/address-config';
import { LowercaseHex, Type } from '../types/structs';
import { SpriteAnimationConfig } from '../types/animation';
import { applyFacetToStats, TOTAL_FACETS } from '../data/facets';

export enum MoveClass {
  Physical = 'Physical',
  Special = 'Special',
  Other = 'Other',
  Self = 'Self',
};

export type MoveInputType = 'none' | 'self-mon' | 'opponent-mon' | 'mode-select';

// Legal slot-target domain for the doubles target step. Authored in moves.csv (the authoritative
// targeting source — there is no Solidity enum); validateMoves.py checks each move's targetBits
// behavior against it.
export type MoveTargetSpec = 'any-other-slot' | 'none' | 'self-only' | 'opponent-slot' | 'ally-slot' | 'any-subset';

export const MonMetadata = {
  0: {
    "id": 0,
    "name": "Ghouliath",
    "flavor": "Often found in dark places like caves and OTC trading desks.",
    "sprites": {
      "frontIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[768, 192], [864, 192], [960, 192], [1056, 192]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "contentTop": 17,
        "contentBottom": 78,
        "contentLeft": 21,
        "contentRight": 74
      },
      "frontSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[1440, 288], [1344, 288], [1248, 288], [1152, 288], [1056, 288], [960, 288], [864, 288], [768, 288]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[768, 288], [864, 288], [960, 288], [1056, 288], [1152, 288], [1248, 288], [1344, 288], [1440, 288]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontHurt": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[1152, 192], [0, 288], [96, 288], [192, 288]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[576, 192], [672, 192]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 167,
        "loop": true,
        "contentTop": 2,
        "contentBottom": 96,
        "contentLeft": 2,
        "contentRight": 79
      },
      "backSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[672, 288], [576, 288], [480, 288], [384, 288], [288, 288], [192, 288], [96, 288], [0, 288]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[0, 288], [96, 288], [192, 288], [288, 288], [384, 288], [480, 288], [576, 288], [672, 288]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "mini": {
        "spritesheetUrl": "/assets/mons/all/mon_mini.png",
        "frames": [[0, 32], [32, 32]],
        "frameWidth": 32,
        "frameHeight": 32,
        "frameDurationMs": 167,
        "loop": true
      },
      "micro": {
        "spritesheetUrl": "/assets/mons/all/mon_micro.png",
        "frames": [[0, 16], [16, 16]],
        "frameWidth": 16,
        "frameHeight": 16,
        "frameDurationMs": 167,
        "loop": true
      },
      "shadow": {
        "spritesheetUrl": "/assets/mons/all/mon_shadow.png",
        "frames": [[288, 96], [384, 96], [480, 96], [576, 96]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "cx": 47.0
      }
    },
    "stats": {
      "hp": 303,
      "attack": 157,
      "defense": 202,
      "specialAttack": 151,
      "specialDefense": 202,
      "speed": 181
    },
    "type1": Type.Yin,
    "type2": Type.Fire,
    "moves": [
      {
        "address": Address.ETERNAL_GRUDGE,
        "name": "Eternal Grudge",
        "power": 0,
        "stamina": 2,
        "accuracy": 100,
        "priority": 1,
        "type": Type.Yin,
        "class": MoveClass.Self,
        "description": "KO’s self. In return, halves the opponent's ATK and SpATK.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0
      },
      {
        "address": Address.INFERNAL_FLAME,
        "name": "Infernal Flame",
        "power": 120,
        "stamina": 2,
        "accuracy": 85,
        "priority": 0,
        "type": Type.Fire,
        "class": MoveClass.Special,
        "description": "Deals damage, 30% chance of inflicting Burn.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[1920, 576], [2016, 576], [2112, 576], [2208, 576], [2304, 576], [2400, 576], [0, 672], [96, 672], [192, 672], [288, 672], [384, 672], [480, 672], [576, 672], [672, 672], [768, 672], [864, 672], [960, 672], [1056, 672], [1152, 672], [1248, 672], [1344, 672], [1440, 672], [1536, 672], [1632, 672], [1728, 672]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      },
      {
        "address": Address.WITHER_AWAY,
        "name": "Wither Away",
        "power": 60,
        "stamina": 3,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Yin,
        "class": MoveClass.Special,
        "description": "Deals damage, and then inflicts Panic on both players.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[96, 2208], [192, 2208], [288, 2208], [384, 2208], [480, 2208], [576, 2208], [672, 2208], [768, 2208], [864, 2208], [960, 2208], [1056, 2208], [1152, 2208], [1248, 2208], [1344, 2208], [1440, 2208], [1536, 2208]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      },
      {
        "address": Address.OSTEOPOROSIS,
        "name": "Osteoporosis",
        "power": 90,
        "stamina": 2,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Yin,
        "class": MoveClass.Physical,
        "description": "Deals damage.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "inlineKey": "0x5a0020000000000000000000"
      },
      {
        "address": Address.GRAVE_AFFLICTION,
        "name": "Grave Affliction",
        "power": 0,
        "stamina": 2,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Yin,
        "class": MoveClass.Other,
        "description": "If the opposing mon has a status condition, both mons lose half their current HP.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 6
      }
    ],
    "ability": {
      "address": Address.RISE_FROM_THE_GRAVE,
      "name": "Rise From The Grave",
      "effect": "Once per game, after being KO'ed, Ghouliath revives after 3 turns with 1 HP."
    }
  },
  1: {
    "id": 1,
    "name": "Inutia",
    "flavor": "A little jumpy. Nose is always wet.",
    "sprites": {
      "frontIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[1056, 480], [1152, 480], [0, 576], [96, 576]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "contentTop": 20,
        "contentBottom": 76,
        "contentLeft": 16,
        "contentRight": 77
      },
      "frontSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[1440, 672], [1344, 672], [1248, 672], [1152, 672], [1056, 672], [960, 672], [864, 672], [768, 672]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[768, 672], [864, 672], [960, 672], [1056, 672], [1152, 672], [1248, 672], [1344, 672], [1440, 672]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontHurt": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[192, 576], [288, 576], [384, 576], [480, 576]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[864, 480], [960, 480]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 167,
        "loop": true,
        "contentTop": 19,
        "contentBottom": 96,
        "contentLeft": 0,
        "contentRight": 78
      },
      "backSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[672, 672], [576, 672], [480, 672], [384, 672], [288, 672], [192, 672], [96, 672], [0, 672]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[0, 672], [96, 672], [192, 672], [288, 672], [384, 672], [480, 672], [576, 672], [672, 672]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "mini": {
        "spritesheetUrl": "/assets/mons/all/mon_mini.png",
        "frames": [[64, 64], [96, 64]],
        "frameWidth": 32,
        "frameHeight": 32,
        "frameDurationMs": 167,
        "loop": true
      },
      "micro": {
        "spritesheetUrl": "/assets/mons/all/mon_micro.png",
        "frames": [[32, 32], [48, 32]],
        "frameWidth": 16,
        "frameHeight": 16,
        "frameDurationMs": 167,
        "loop": true
      },
      "shadow": {
        "spritesheetUrl": "/assets/mons/all/mon_shadow.png",
        "frames": [[96, 288], [192, 288], [288, 288], [384, 288]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "cx": 46.0
      }
    },
    "stats": {
      "hp": 351,
      "attack": 171,
      "defense": 189,
      "specialAttack": 175,
      "specialDefense": 192,
      "speed": 229
    },
    "type1": Type.Faith,
    "type2": null,
    "moves": [
      {
        "address": Address.CHAIN_EXPANSION,
        "name": "Chain Expansion",
        "power": 0,
        "stamina": 1,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Faith,
        "class": MoveClass.Other,
        "description": "Sets up battlefield effect with 4 charges. During a switch-in: an enemy takes damage scaled by its Faith weakness; a friendly switch-in heals 12.5% of max HP. ",
        "inputType": "none",
        "targetSpec": "none",
        "unlockLevel": 0,
        "overlayPlacement": "canvas-full",
        "sprite": {
          "spritesheetUrl": "/assets/attacks/non_standard_spritesheet.png",
          "frames": [[0, 530], [360, 530], [720, 530], [1080, 530], [1440, 530], [1800, 530], [0, 710], [360, 710], [720, 710], [1080, 710], [1440, 710], [1800, 710], [0, 890], [360, 890], [720, 890], [1080, 890], [1440, 890], [1800, 890], [0, 1070], [360, 1070], [720, 1070], [1080, 1070], [1440, 1070], [1800, 1070], [0, 1250], [360, 1250], [720, 1250], [1080, 1250], [1440, 1250], [1800, 1250]],
          "frameWidth": 360,
          "frameHeight": 180,
          "frameDurationMs": 83,
          "loop": false
        }
      },
      {
        "address": Address.INITIALIZE,
        "name": "Initialize",
        "power": 0,
        "stamina": 2,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Faith,
        "class": MoveClass.Self,
        "description": "Boosts ATK/SpATK by 50%. Can only be used once per switch-in. When Inutia switches out, the bonus is transferred to the next incoming mon.",
        "inputType": "none",
        "targetSpec": "self-only",
        "unlockLevel": 0,
        "descriptionTemplate": "Boosts ATK/SpATK by 50%. Usable once per switch-in ({availability}). On switch-out, the bonus transfers to the next incoming mon."
      },
      {
        "address": Address.BIG_BITE,
        "name": "Big Bite",
        "power": 80,
        "stamina": 2,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Faith,
        "class": MoveClass.Physical,
        "description": "Deals damage.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "inlineKey": "0x500920000000000000000000"
      },
      {
        "address": Address.HIT_AND_DIP,
        "name": "Hit And Dip",
        "power": 60,
        "stamina": 2,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Faith,
        "class": MoveClass.Special,
        "description": "Deals damage, then swaps out.",
        "inputType": "self-mon",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0
      },
      {
        "address": Address.SANCTIFY,
        "name": "Sanctify",
        "power": 0,
        "stamina": 2,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Faith,
        "class": MoveClass.Other,
        "description": "Blesses a team member: it takes no damage from the next source of damage, then heals 1/16 max HP when Blessed ends.",
        "inputType": "self-mon",
        "targetSpec": "none",
        "unlockLevel": 6,
        "overlayPlacement": "self",
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[288, 1536], [384, 1536], [480, 1536], [576, 1536], [672, 1536], [768, 1536], [864, 1536], [960, 1536], [1056, 1536], [1152, 1536], [1248, 1536], [1344, 1536], [1440, 1536], [1536, 1536], [1632, 1536], [1728, 1536], [1824, 1536], [1920, 1536]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      }
    ],
    "ability": {
      "address": Address.INTERWEAVING,
      "name": "Interweaving",
      "effect": "When Inutia swaps in, the opposing mon's ATK decreases 15%. When Inutia swaps out, the opposing mon's SpATK decreases 15%."
    }
  },
  2: {
    "id": 2,
    "name": "Malalien",
    "flavor": "Do not approach or be approached.",
    "sprites": {
      "frontIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[768, 576], [864, 576], [960, 576], [1056, 576]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "contentTop": 16,
        "contentBottom": 80,
        "contentLeft": 29,
        "contentRight": 64
      },
      "frontSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[1440, 768], [1344, 768], [1248, 768], [1152, 768], [1056, 768], [960, 768], [864, 768], [768, 768]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[768, 768], [864, 768], [960, 768], [1056, 768], [1152, 768], [1248, 768], [1344, 768], [1440, 768]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontHurt": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[1152, 576], [0, 672], [96, 672], [192, 672]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[576, 576], [672, 576]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 167,
        "loop": true,
        "contentTop": 9,
        "contentBottom": 96,
        "contentLeft": 5,
        "contentRight": 65
      },
      "backSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[672, 768], [576, 768], [480, 768], [384, 768], [288, 768], [192, 768], [96, 768], [0, 768]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[0, 768], [96, 768], [192, 768], [288, 768], [384, 768], [480, 768], [576, 768], [672, 768]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "mini": {
        "spritesheetUrl": "/assets/mons/all/mon_mini.png",
        "frames": [[128, 64], [160, 64]],
        "frameWidth": 32,
        "frameHeight": 32,
        "frameDurationMs": 167,
        "loop": true
      },
      "micro": {
        "spritesheetUrl": "/assets/mons/all/mon_micro.png",
        "frames": [[64, 32], [80, 32]],
        "frameWidth": 16,
        "frameHeight": 16,
        "frameDurationMs": 167,
        "loop": true
      },
      "shadow": {
        "spritesheetUrl": "/assets/mons/all/mon_shadow.png",
        "frames": [[480, 288], [576, 288], [672, 288], [768, 288]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "cx": 48.0
      }
    },
    "stats": {
      "hp": 258,
      "attack": 121,
      "defense": 125,
      "specialAttack": 322,
      "specialDefense": 151,
      "speed": 308
    },
    "type1": Type.Cyber,
    "type2": null,
    "moves": [
      {
        "address": Address.TRIPLE_THINK,
        "name": "Triple Think",
        "power": 0,
        "stamina": 2,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Math,
        "class": MoveClass.Self,
        "description": "Boosts SpATK by 75%.",
        "inputType": "none",
        "targetSpec": "self-only",
        "unlockLevel": 0,
        "overlayPlacement": "self",
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[1632, 1920], [1728, 1920], [1824, 1920], [1920, 1920], [2016, 1920], [2112, 1920], [2208, 1920], [2304, 1920], [2400, 1920], [0, 2016]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      },
      {
        "address": Address.FEDERAL_INVESTIGATION,
        "name": "Federal Investigation",
        "power": 100,
        "stamina": 3,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Cyber,
        "class": MoveClass.Special,
        "description": "Deals damage.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "inlineKey": "0x644c30000000000000000000",
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[1152, 480], [1248, 480], [1344, 480], [1440, 480], [1536, 480], [1632, 480], [1728, 480], [1824, 480], [1920, 480], [2016, 480], [2112, 480], [2208, 480], [2304, 480], [2400, 480], [0, 576], [96, 576], [192, 576], [288, 576]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      },
      {
        "address": Address.NEGATIVE_THOUGHTS,
        "name": "Negative Thoughts",
        "power": 80,
        "stamina": 3,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Math,
        "class": MoveClass.Special,
        "description": "Deals damage, 10% chance to cause Panic.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "inlineKey": "0x504b30a00000000000000000",
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[1920, 1152], [2016, 1152], [2112, 1152], [2208, 1152], [2304, 1152], [2400, 1152], [0, 1248], [96, 1248], [192, 1248], [288, 1248], [384, 1248], [480, 1248], [576, 1248], [672, 1248], [768, 1248], [864, 1248], [960, 1248], [1056, 1248]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      },
      {
        "address": Address.INFINITE_LOVE,
        "name": "Infinite Love",
        "power": 90,
        "stamina": 3,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Cosmic,
        "class": MoveClass.Special,
        "description": "Deals damage, 10% chance to cause Sleep.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "inlineKey": "0x5a4d30a00000000000000000",
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[1824, 672], [1920, 672], [2016, 672], [2112, 672], [2208, 672], [2304, 672], [2400, 672], [0, 768], [96, 768], [192, 768], [288, 768], [384, 768], [480, 768], [576, 768], [672, 768], [768, 768], [864, 768], [960, 768], [1056, 768], [1152, 768], [1248, 768], [1344, 768], [1440, 768], [1536, 768], [1632, 768]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      },
      {
        "address": Address.FOUL_LANGUAGE,
        "name": "Foul Language",
        "power": 60,
        "stamina": 2,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Cyber,
        "class": MoveClass.Special,
        "description": "Deals damage. Half of the damage done is taken as recoil.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 6
      }
    ],
    "ability": {
      "address": Address.ACTUS_REUS,
      "name": "Actus Reus",
      "effect": "If Malalien KO's an opposing mon, they gain an Indictment. Upon KO, if they have an Indictment, Malalien cripples their murderer."
    }
  },
  3: {
    "id": 3,
    "name": "Iblivion",
    "flavor": "Many say it has great potential for growth.",
    "sprites": {
      "frontIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[96, 480], [192, 480], [288, 480], [384, 480]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "contentTop": 18,
        "contentBottom": 81,
        "contentLeft": 18,
        "contentRight": 79
      },
      "frontSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[1440, 576], [1344, 576], [1248, 576], [1152, 576], [1056, 576], [960, 576], [864, 576], [768, 576]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[768, 576], [864, 576], [960, 576], [1056, 576], [1152, 576], [1248, 576], [1344, 576], [1440, 576]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontHurt": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[480, 480], [576, 480], [672, 480], [768, 480]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[1152, 384], [0, 480]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 167,
        "loop": true,
        "contentTop": 13,
        "contentBottom": 96,
        "contentLeft": 0,
        "contentRight": 93
      },
      "backSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[672, 576], [576, 576], [480, 576], [384, 576], [288, 576], [192, 576], [96, 576], [0, 576]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[0, 576], [96, 576], [192, 576], [288, 576], [384, 576], [480, 576], [576, 576], [672, 576]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "mini": {
        "spritesheetUrl": "/assets/mons/all/mon_mini.png",
        "frames": [[0, 64], [32, 64]],
        "frameWidth": 32,
        "frameHeight": 32,
        "frameDurationMs": 167,
        "loop": true
      },
      "micro": {
        "spritesheetUrl": "/assets/mons/all/mon_micro.png",
        "frames": [[0, 32], [16, 32]],
        "frameWidth": 16,
        "frameHeight": 16,
        "frameDurationMs": 167,
        "loop": true
      },
      "shadow": {
        "spritesheetUrl": "/assets/mons/all/mon_shadow.png",
        "frames": [[576, 192], [672, 192], [768, 192], [0, 288]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "cx": 48.0
      }
    },
    "stats": {
      "hp": 277,
      "attack": 199,
      "defense": 164,
      "specialAttack": 180,
      "specialDefense": 168,
      "speed": 256
    },
    "type1": Type.Yang,
    "type2": Type.Air,
    "moves": [
      {
        "address": Address.UNBOUNDED_STRIKE,
        "name": "Unbounded Strike",
        "power": "?",
        "stamina": "?",
        "accuracy": 100,
        "priority": 0,
        "type": Type.Air,
        "class": MoveClass.Physical,
        "description": "Consume 3 Baselight stacks to deal 130 damage at 1 stamina cost. Otherwise, deals 80 damage at 2 stamina cost.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "descriptionTemplate": "Deals {power} damage at {stamina} stamina cost. Consumes 3 Baselight stacks when available; otherwise deals 80 at 2.",
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[96, 2016], [192, 2016], [288, 2016], [384, 2016], [480, 2016], [576, 2016], [672, 2016], [768, 2016], [864, 2016], [960, 2016], [1056, 2016], [1152, 2016]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      },
      {
        "address": Address.LOOP,
        "name": "Loop",
        "power": 0,
        "stamina": 1,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Yang,
        "class": MoveClass.Self,
        "description": "Sets all stats to +20%/35%/50% based on Baselight level. Does not stack.",
        "inputType": "none",
        "targetSpec": "self-only",
        "unlockLevel": 0,
        "descriptionTemplate": "Raises all stats by {boost}% based on Baselight level.",
        "overlayPlacement": "self",
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[1728, 768], [1824, 768], [1920, 768], [2016, 768], [2112, 768], [2208, 768], [2304, 768], [2400, 768], [0, 864], [96, 864], [192, 864], [288, 864], [384, 864], [480, 864], [576, 864], [672, 864], [768, 864], [864, 864]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      },
      {
        "address": Address.BRIGHTBACK,
        "name": "Brightback",
        "power": 70,
        "stamina": 2,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Yang,
        "class": MoveClass.Physical,
        "description": "Deals damage. Consume 1 Baselight stack to heal for 50% of damage dealt.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "descriptionTemplate": "Deals damage. Heal for 50% of damage dealt by consuming 1 Baselight stack ({healStatus}).",
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[0, 0], [96, 0], [192, 0], [288, 0], [384, 0], [480, 0], [576, 0], [672, 0], [768, 0], [864, 0], [960, 0], [1056, 0], [1152, 0], [1248, 0], [1344, 0], [1440, 0], [1536, 0], [1632, 0], [1728, 0], [1824, 0], [1920, 0], [2016, 0], [2112, 0], [2208, 0]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      },
      {
        "address": Address.RENORMALIZE,
        "name": "Renormalize",
        "power": 0,
        "stamina": 0,
        "accuracy": 100,
        "priority": -1,
        "type": Type.Yang,
        "class": MoveClass.Self,
        "description": "Sets Baselight level to 3. Clears all stat boosts, positive or negative.",
        "inputType": "none",
        "targetSpec": "self-only",
        "unlockLevel": 0
      }
    ],
    "ability": {
      "address": Address.BASELIGHT,
      "name": "Baselight",
      "effect": "Whenever Iblivion takes damage, it gains a Baselight point. Points can be used to empower moves."
    }
  },
  4: {
    "id": 4,
    "name": "Gorillax",
    "flavor": "Big.",
    "sprites": {
      "frontIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[384, 384], [480, 384], [576, 384], [672, 384]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "contentTop": 7,
        "contentBottom": 89,
        "contentLeft": 16,
        "contentRight": 79
      },
      "frontSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[1440, 480], [1344, 480], [1248, 480], [1152, 480], [1056, 480], [960, 480], [864, 480], [768, 480]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[768, 480], [864, 480], [960, 480], [1056, 480], [1152, 480], [1248, 480], [1344, 480], [1440, 480]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontHurt": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[768, 384], [864, 384], [960, 384], [1056, 384]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[192, 384], [288, 384]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 167,
        "loop": true,
        "contentTop": 7,
        "contentBottom": 96,
        "contentLeft": 0,
        "contentRight": 94
      },
      "backSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[672, 480], [576, 480], [480, 480], [384, 480], [288, 480], [192, 480], [96, 480], [0, 480]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[0, 480], [96, 480], [192, 480], [288, 480], [384, 480], [480, 480], [576, 480], [672, 480]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "mini": {
        "spritesheetUrl": "/assets/mons/all/mon_mini.png",
        "frames": [[128, 32], [160, 32]],
        "frameWidth": 32,
        "frameHeight": 32,
        "frameDurationMs": 167,
        "loop": true
      },
      "micro": {
        "spritesheetUrl": "/assets/mons/all/mon_micro.png",
        "frames": [[64, 16], [80, 16]],
        "frameWidth": 16,
        "frameHeight": 16,
        "frameDurationMs": 167,
        "loop": true
      },
      "shadow": {
        "spritesheetUrl": "/assets/mons/all/mon_shadow.png",
        "frames": [[192, 192], [288, 192], [384, 192], [480, 192]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "cx": 47.0
      }
    },
    "stats": {
      "hp": 407,
      "attack": 302,
      "defense": 175,
      "specialAttack": 112,
      "specialDefense": 176,
      "speed": 129
    },
    "type1": Type.Earth,
    "type2": null,
    "moves": [
      {
        "address": Address.ROCK_PULL,
        "name": "Rock Pull",
        "power": "?",
        "stamina": 3,
        "accuracy": 100,
        "priority": "?",
        "type": Type.Earth,
        "class": MoveClass.Physical,
        "description": "If the opponent is attempting to switch out, deals heavy damage. Otherwise, deals damage to self.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0
      },
      {
        "address": Address.POUND_GROUND,
        "name": "Pound Ground",
        "power": 95,
        "stamina": 3,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Earth,
        "class": MoveClass.Physical,
        "description": "Deals damage.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "inlineKey": "0x5f0230000000000000000000",
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[1152, 1248], [1248, 1248], [1344, 1248], [1440, 1248], [1536, 1248], [1632, 1248], [1728, 1248], [1824, 1248], [1920, 1248], [2016, 1248], [2112, 1248], [2208, 1248], [2304, 1248], [2400, 1248], [0, 1344], [96, 1344], [192, 1344], [288, 1344], [384, 1344], [480, 1344], [576, 1344]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      },
      {
        "address": Address.BLOW,
        "name": "Blow",
        "power": 70,
        "stamina": 2,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Air,
        "class": MoveClass.Physical,
        "description": "Deals damage.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "inlineKey": "0x460a20000000000000000000"
      },
      {
        "address": Address.THROW_PEBBLE,
        "name": "Throw Pebble",
        "power": 40,
        "stamina": 1,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Earth,
        "class": MoveClass.Physical,
        "description": "Deals damage.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "inlineKey": "0x280210000000000000000000",
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[288, 1920], [384, 1920], [480, 1920], [576, 1920], [672, 1920], [768, 1920], [864, 1920], [960, 1920], [1056, 1920], [1152, 1920], [1248, 1920], [1344, 1920], [1440, 1920], [1536, 1920]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      }
    ],
    "ability": {
      "address": Address.ANGERY,
      "name": "Angery",
      "effect": "Each time Gorillax takes damage, they get Angerier. At 3 stacks, they heal for 16.6% of max HP."
    }
  },
  5: {
    "id": 5,
    "name": "Sofabbi",
    "flavor": "Their carrots make for a good stew.",
    "sprites": {
      "frontIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[576, 960], [672, 960], [768, 960], [864, 960]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 167,
        "loop": true,
        "contentTop": 20,
        "contentBottom": 80,
        "contentLeft": 20,
        "contentRight": 69
      },
      "frontSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[1440, 1152], [1344, 1152], [1248, 1152], [1152, 1152], [1056, 1152], [960, 1152], [864, 1152], [768, 1152]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[768, 1152], [864, 1152], [960, 1152], [1056, 1152], [1152, 1152], [1248, 1152], [1344, 1152], [1440, 1152]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontHurt": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[960, 960], [1056, 960], [1152, 960], [0, 1056]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[384, 960], [480, 960]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 167,
        "loop": true,
        "contentTop": 25,
        "contentBottom": 96,
        "contentLeft": 1,
        "contentRight": 90
      },
      "backSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[672, 1152], [576, 1152], [480, 1152], [384, 1152], [288, 1152], [192, 1152], [96, 1152], [0, 1152]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[0, 1152], [96, 1152], [192, 1152], [288, 1152], [384, 1152], [480, 1152], [576, 1152], [672, 1152]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "mini": {
        "spritesheetUrl": "/assets/mons/all/mon_mini.png",
        "frames": [[0, 128], [32, 128]],
        "frameWidth": 32,
        "frameHeight": 32,
        "frameDurationMs": 167,
        "loop": true
      },
      "micro": {
        "spritesheetUrl": "/assets/mons/all/mon_micro.png",
        "frames": [[0, 64], [16, 64]],
        "frameWidth": 16,
        "frameHeight": 16,
        "frameDurationMs": 167,
        "loop": true
      },
      "shadow": {
        "spritesheetUrl": "/assets/mons/all/mon_shadow.png",
        "frames": [[192, 576], [288, 576], [384, 576], [480, 576]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 167,
        "loop": true,
        "cx": 44.0
      }
    },
    "stats": {
      "hp": 333,
      "attack": 180,
      "defense": 201,
      "specialAttack": 120,
      "specialDefense": 269,
      "speed": 175
    },
    "type1": Type.Nature,
    "type2": null,
    "moves": [
      {
        "address": Address.GACHACHACHA,
        "name": "Gachachacha",
        "power": "?",
        "stamina": 3,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Cyber,
        "class": MoveClass.Physical,
        "description": "Uniformly random power from 0 to 200. Small chance to KO self or opponent.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "overlayPlacement": "canvas-center",
        "sprite": {
          "normal": {
            "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
            "frames": [[1632, 2208], [1728, 2208], [1824, 2208], [1824, 2208], [1920, 2208], [2016, 2208], [1632, 2208], [1632, 2208], [1632, 2208], [2112, 2208], [2208, 2208], [2304, 2208], [2400, 2208], [2112, 2208], [96, 2304], [384, 2304], [672, 2304], [960, 2304], [1248, 2304], [1536, 2304], [1824, 2304], [2112, 2304], [2400, 2304], [192, 2400], [384, 2400], [384, 2400], [384, 2400]],
            "frameWidth": 96,
            "frameHeight": 96,
            "frameDurationMs": 83,
            "loop": false
          },
          "oppKO": {
            "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
            "frames": [[1632, 2208], [1728, 2208], [1824, 2208], [1824, 2208], [1920, 2208], [2016, 2208], [1632, 2208], [1632, 2208], [1632, 2208], [2112, 2208], [2208, 2208], [2304, 2208], [2400, 2208], [2112, 2208], [0, 2304], [288, 2304], [576, 2304], [864, 2304], [1152, 2304], [1440, 2304], [1728, 2304], [2016, 2304], [2304, 2304], [96, 2400], [384, 2400], [384, 2400], [384, 2400]],
            "frameWidth": 96,
            "frameHeight": 96,
            "frameDurationMs": 83,
            "loop": false
          },
          "selfKO": {
            "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
            "frames": [[1632, 2208], [1728, 2208], [1824, 2208], [1824, 2208], [1920, 2208], [2016, 2208], [1632, 2208], [1632, 2208], [1632, 2208], [2112, 2208], [2208, 2208], [2304, 2208], [2400, 2208], [2112, 2208], [192, 2304], [480, 2304], [768, 2304], [1056, 2304], [1344, 2304], [1632, 2304], [1920, 2304], [2208, 2304], [0, 2400], [288, 2400], [384, 2400], [384, 2400], [384, 2400]],
            "frameWidth": 96,
            "frameHeight": 96,
            "frameDurationMs": 83,
            "loop": false
          }
        }
      },
      {
        "address": Address.GUEST_FEATURE,
        "name": "Guest Feature",
        "power": 75,
        "stamina": 3,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Cyber,
        "class": MoveClass.Physical,
        "description": "Attack Type is set to be the first Type of another selected party member.",
        "inputType": "self-mon",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0
      },
      {
        "address": Address.UNEXPECTED_CARROT,
        "name": "Unexpected Carrot",
        "power": 120,
        "stamina": 4,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Nature,
        "class": MoveClass.Physical,
        "description": "Deals damage.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "inlineKey": "0x780740000000000000000000",
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[1248, 2016], [1344, 2016], [1440, 2016], [1536, 2016], [1632, 2016], [1728, 2016], [1824, 2016], [1920, 2016], [2016, 2016], [2112, 2016], [2208, 2016], [2304, 2016], [2400, 2016], [0, 2112], [96, 2112], [192, 2112]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      },
      {
        "address": Address.SNACK_BREAK,
        "name": "Snack Break",
        "power": 0,
        "stamina": 1,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Nature,
        "class": MoveClass.Self,
        "description": "Heal for 50% of health. Effectiveness reduces by half each time.",
        "inputType": "none",
        "targetSpec": "self-only",
        "unlockLevel": 0,
        "descriptionTemplate": "Heal for {pct}% (1/{denom}) of max HP. Effectiveness halves each use, min 1/16 (6.25%)."
      }
    ],
    "ability": {
      "address": Address.CARROT_HARVEST,
      "name": "Carrot Harvest",
      "effect": "At the end of every turn, Sofabbi has a 50% chance of regaining 1 stamina."
    }
  },
  6: {
    "id": 6,
    "name": "Pengym",
    "flavor": "Even their ice contains a lot of protein.",
    "sprites": {
      "frontIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[864, 864], [960, 864], [1056, 864], [1152, 864]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "contentTop": 21,
        "contentBottom": 88,
        "contentLeft": 19,
        "contentRight": 75
      },
      "frontSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[1440, 1056], [1344, 1056], [1248, 1056], [1152, 1056], [1056, 1056], [960, 1056], [864, 1056], [768, 1056]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[768, 1056], [864, 1056], [960, 1056], [1056, 1056], [1152, 1056], [1248, 1056], [1344, 1056], [1440, 1056]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontHurt": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[0, 960], [96, 960], [192, 960], [288, 960]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[672, 864], [768, 864]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 167,
        "loop": true,
        "contentTop": 14,
        "contentBottom": 96,
        "contentLeft": 0,
        "contentRight": 91
      },
      "backSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[672, 1056], [576, 1056], [480, 1056], [384, 1056], [288, 1056], [192, 1056], [96, 1056], [0, 1056]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[0, 1056], [96, 1056], [192, 1056], [288, 1056], [384, 1056], [480, 1056], [576, 1056], [672, 1056]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "mini": {
        "spritesheetUrl": "/assets/mons/all/mon_mini.png",
        "frames": [[128, 96], [160, 96]],
        "frameWidth": 32,
        "frameHeight": 32,
        "frameDurationMs": 167,
        "loop": true
      },
      "micro": {
        "spritesheetUrl": "/assets/mons/all/mon_micro.png",
        "frames": [[64, 48], [80, 48]],
        "frameWidth": 16,
        "frameHeight": 16,
        "frameDurationMs": 167,
        "loop": true
      },
      "shadow": {
        "spritesheetUrl": "/assets/mons/all/mon_shadow.png",
        "frames": [[672, 480], [768, 480], [0, 576], [96, 576]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "cx": 47.0
      }
    },
    "stats": {
      "hp": 371,
      "attack": 212,
      "defense": 191,
      "specialAttack": 233,
      "specialDefense": 172,
      "speed": 149
    },
    "type1": Type.Ice,
    "type2": null,
    "moves": [
      {
        "address": Address.CHILL_OUT,
        "name": "Chill Out",
        "power": 0,
        "stamina": 0,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Ice,
        "class": MoveClass.Other,
        "description": "Inflicts Frostbite on the opponent.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "inlineKey": "0xc606400000000000000000",
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[2112, 96], [2208, 96], [2304, 96], [2400, 96], [0, 192], [96, 192], [192, 192], [288, 192], [384, 192], [480, 192], [576, 192], [672, 192], [768, 192], [864, 192], [960, 192], [1056, 192], [1152, 192], [1248, 192]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      },
      {
        "address": Address.DEADLIFT,
        "name": "Deadlift",
        "power": 0,
        "stamina": 2,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Metal,
        "class": MoveClass.Self,
        "description": "Increases ATK and DEF by 50%.",
        "inputType": "none",
        "targetSpec": "self-only",
        "unlockLevel": 0
      },
      {
        "address": Address.DEEP_FREEZE,
        "name": "Deep Freeze",
        "power": 90,
        "stamina": 3,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Ice,
        "class": MoveClass.Physical,
        "description": "If the target has Frostbite, consumes Frostbite and does double damage (the target's SpATK returns to normal).",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[1152, 288], [1248, 288], [1344, 288], [1440, 288], [1536, 288], [1632, 288], [1728, 288], [1824, 288], [1920, 288], [2016, 288], [2112, 288], [2208, 288], [2304, 288], [2400, 288], [0, 384], [96, 384], [192, 384], [288, 384], [384, 384], [480, 384], [576, 384], [672, 384], [768, 384], [864, 384]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      },
      {
        "address": Address.PISTOL_SQUAT,
        "name": "Pistol Squat",
        "power": 80,
        "stamina": 2,
        "accuracy": 100,
        "priority": -1,
        "type": Type.Metal,
        "class": MoveClass.Physical,
        "description": "Deals damage, then forces the enemy mon to switch to a random living teammate.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0
      }
    ],
    "ability": {
      "address": Address.POST_WORKOUT,
      "name": "Post-Workout",
      "effect": "On swap out, if Pengym has a status condition, heal it (any status). If healed, Pengym regains 1 stamina."
    }
  },
  7: {
    "id": 7,
    "name": "Embursa",
    "flavor": "It will use even its own fur as fuel for its fire.",
    "sprites": {
      "frontIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[1056, 96], [1152, 96], [0, 192], [96, 192]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 167,
        "loop": true,
        "contentTop": 1,
        "contentBottom": 95,
        "contentLeft": 16,
        "contentRight": 82
      },
      "frontSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[1440, 192], [1344, 192], [1248, 192], [1152, 192], [1056, 192], [960, 192], [864, 192], [768, 192]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[768, 192], [864, 192], [960, 192], [1056, 192], [1152, 192], [1248, 192], [1344, 192], [1440, 192]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontHurt": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[192, 192], [288, 192], [384, 192], [480, 192]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[864, 96], [960, 96]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 167,
        "loop": true,
        "contentTop": 1,
        "contentBottom": 96,
        "contentLeft": 0,
        "contentRight": 83
      },
      "backSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[672, 192], [576, 192], [480, 192], [384, 192], [288, 192], [192, 192], [96, 192], [0, 192]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[0, 192], [96, 192], [192, 192], [288, 192], [384, 192], [480, 192], [576, 192], [672, 192]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "mini": {
        "spritesheetUrl": "/assets/mons/all/mon_mini.png",
        "frames": [[128, 0], [160, 0]],
        "frameWidth": 32,
        "frameHeight": 32,
        "frameDurationMs": 167,
        "loop": true
      },
      "micro": {
        "spritesheetUrl": "/assets/mons/all/mon_micro.png",
        "frames": [[64, 0], [80, 0]],
        "frameWidth": 16,
        "frameHeight": 16,
        "frameDurationMs": 167,
        "loop": true
      },
      "shadow": {
        "spritesheetUrl": "/assets/mons/all/mon_shadow.png",
        "frames": [[768, 0], [0, 96], [96, 96], [192, 96]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 167,
        "loop": true,
        "cx": 48.5
      }
    },
    "stats": {
      "hp": 420,
      "attack": 141,
      "defense": 220,
      "specialAttack": 190,
      "specialDefense": 161,
      "speed": 111
    },
    "type1": Type.Fire,
    "type2": null,
    "moves": [
      {
        "address": Address.HONEY_BRIBE,
        "name": "Honey Bribe",
        "power": 0,
        "stamina": 2,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Nature,
        "class": MoveClass.Self,
        "description": "Heals self by 50% of max HP and the opponent by 25% of max HP. Lowers opponent SpDEF by 50% until they switch out. Each usage reduces heal efficiency.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "descriptionTemplate": "Heals self by {selfPct}% (1/{selfDenom}) and opponent by {oppPct}% (1/{oppDenom}) of max HP. Lowers opponent SpDEF by 50%.{priorityNote}"
      },
      {
        "address": Address.SET_ABLAZE,
        "name": "Set Ablaze",
        "power": 90,
        "stamina": 3,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Fire,
        "class": MoveClass.Special,
        "description": "Deals damage, 30% chance of Burn.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[1824, 1632], [1920, 1632], [2016, 1632], [2112, 1632], [2208, 1632], [2304, 1632], [2400, 1632], [0, 1728], [96, 1728], [192, 1728], [288, 1728], [384, 1728], [480, 1728], [576, 1728], [672, 1728], [768, 1728]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      },
      {
        "address": Address.HEAT_BEACON,
        "name": "Heat Beacon",
        "power": 0,
        "stamina": 0,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Fire,
        "class": MoveClass.Self,
        "description": "+1 priority to next turn's move. If Embursa is Burned, inflicts Burn on the opponent.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0
      },
      {
        "address": Address.Q5,
        "name": "Q5",
        "power": 150,
        "stamina": 2,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Fire,
        "class": MoveClass.Special,
        "description": "Deals 150 damage at the start of the 5th round after casting. Only one Q5 can be queued per side at a time.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[672, 1344], [768, 1344], [864, 1344], [960, 1344], [1056, 1344], [1152, 1344], [1248, 1344], [1344, 1344], [1440, 1344], [1536, 1344], [1632, 1344], [1728, 1344], [1824, 1344], [1920, 1344], [2016, 1344], [2112, 1344], [2208, 1344], [2304, 1344], [2400, 1344], [0, 1440], [96, 1440], [192, 1440], [288, 1440], [384, 1440]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      }
    ],
    "ability": {
      "address": Address.TINDERCLAWS,
      "name": "Tinderclaws",
      "effect": "After every move, Embursa has a 33% chance of burning itself. If burned, gain a 50% SpATK boost. When resting, Embursa heals from burn."
    }
  },
  8: {
    "id": 8,
    "name": "Volthare",
    "flavor": "Its mental circuitry is often scattered because of its high speed.",
    "sprites": {
      "frontIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[288, 1056], [384, 1056], [480, 1056], [576, 1056]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "contentTop": 10,
        "contentBottom": 85,
        "contentLeft": 23,
        "contentRight": 74
      },
      "frontSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[1440, 1248], [1344, 1248], [1248, 1248], [1152, 1248], [1056, 1248], [960, 1248], [864, 1248], [768, 1248]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[768, 1248], [864, 1248], [960, 1248], [1056, 1248], [1152, 1248], [1248, 1248], [1344, 1248], [1440, 1248]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontHurt": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[672, 1056], [768, 1056], [864, 1056], [960, 1056]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[96, 1056], [192, 1056]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 167,
        "loop": true,
        "contentTop": 0,
        "contentBottom": 96,
        "contentLeft": 0,
        "contentRight": 87
      },
      "backSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[672, 1248], [576, 1248], [480, 1248], [384, 1248], [288, 1248], [192, 1248], [96, 1248], [0, 1248]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[0, 1248], [96, 1248], [192, 1248], [288, 1248], [384, 1248], [480, 1248], [576, 1248], [672, 1248]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "mini": {
        "spritesheetUrl": "/assets/mons/all/mon_mini.png",
        "frames": [[64, 128], [96, 128]],
        "frameWidth": 32,
        "frameHeight": 32,
        "frameDurationMs": 167,
        "loop": true
      },
      "micro": {
        "spritesheetUrl": "/assets/mons/all/mon_micro.png",
        "frames": [[32, 64], [48, 64]],
        "frameWidth": 16,
        "frameHeight": 16,
        "frameDurationMs": 167,
        "loop": true
      },
      "shadow": {
        "spritesheetUrl": "/assets/mons/all/mon_shadow.png",
        "frames": [[576, 576], [672, 576], [768, 576], [0, 672]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "cx": 48.5
      }
    },
    "stats": {
      "hp": 310,
      "attack": 120,
      "defense": 184,
      "specialAttack": 255,
      "specialDefense": 176,
      "speed": 311
    },
    "type1": Type.Lightning,
    "type2": Type.Cyber,
    "moves": [
      {
        "address": Address.ELECTROCUTE,
        "name": "Electrocute",
        "power": 90,
        "stamina": 2,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Lightning,
        "class": MoveClass.Special,
        "description": "Deals damage, 10% chance to cause Zap. A Zapped mon skips its next turn.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "inlineKey": "0x5a4820a00000000000000000",
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[2112, 384], [2208, 384], [2304, 384], [2400, 384], [0, 480], [96, 480], [192, 480], [288, 480], [384, 480], [480, 480], [576, 480], [672, 480], [768, 480], [864, 480], [960, 480], [1056, 480]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      },
      {
        "address": Address.ROUND_TRIP,
        "name": "Round Trip",
        "power": 30,
        "stamina": 1,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Lightning,
        "class": MoveClass.Special,
        "description": "Deals damage, then switches out.",
        "inputType": "self-mon",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[1440, 1440], [1536, 1440], [1632, 1440], [1728, 1440], [1824, 1440], [1920, 1440], [2016, 1440], [2112, 1440], [2208, 1440], [2304, 1440], [2400, 1440], [0, 1536], [96, 1536], [192, 1536]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      },
      {
        "address": Address.MEGA_STAR_BLAST,
        "name": "Mega Star Blast",
        "power": 150,
        "stamina": 3,
        "accuracy": "?",
        "priority": 2,
        "type": Type.Lightning,
        "class": MoveClass.Special,
        "description": "If used during Overclock, clears Overclock and accuracy is 100%. Otherwise accuracy is 60%. Deals damage, 30% chance to inflict Zap.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "descriptionTemplate": "+2 priority. Accuracy {accuracy}% (100 during Overclock, else 60). Deals damage, 30% chance to cause Zap. Clears Overclock if active.",
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[960, 864], [1056, 864], [1152, 864], [1248, 864], [1344, 864], [1440, 864], [1536, 864], [1632, 864], [1728, 864], [1824, 864], [1920, 864], [2016, 864], [2112, 864], [2208, 864], [2304, 864], [2400, 864], [0, 960], [96, 960], [192, 960], [288, 960], [384, 960], [480, 960], [576, 960], [672, 960], [768, 960], [864, 960], [960, 960], [1056, 960], [1152, 960], [1248, 960], [1344, 960], [1440, 960], [1536, 960], [1632, 960], [1728, 960], [1824, 960], [1920, 960], [2016, 960], [2112, 960], [2208, 960]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 42,
          "loop": false
        }
      },
      {
        "address": Address.DUAL_SHOCK,
        "name": "Dual Shock",
        "power": 60,
        "stamina": 0,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Cyber,
        "class": MoveClass.Special,
        "description": "Deals damage and inflicts Zap on self. Overclocks your team",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[960, 384], [1056, 384], [1152, 384], [1248, 384], [1344, 384], [1440, 384], [1536, 384], [1632, 384], [1728, 384], [1824, 384], [1920, 384], [2016, 384]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      },
      {
        "address": Address.QUICKSTORM,
        "name": "Quickstorm",
        "power": 30,
        "stamina": 2,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Lightning,
        "class": MoveClass.Special,
        "description": "Inflicts Zap on the opponent. Only usable the turn Volthare enters.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 6,
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[480, 1440], [576, 1440], [672, 1440], [768, 1440], [864, 1440], [960, 1440], [1056, 1440], [1152, 1440], [1248, 1440], [1344, 1440]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      }
    ],
    "ability": {
      "address": Address.PREEMPTIVE_SHOCK,
      "name": "Preemptive Shock",
      "effect": "When Volthare swaps in, they deal a small amount of damage to the opposing mon."
    }
  },
  9: {
    "id": 9,
    "name": "Aurox",
    "flavor": "Its gold sheen never fades away, serving as a symbol of optimism.",
    "sprites": {
      "frontIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[192, 0], [288, 0], [384, 0], [480, 0]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "contentTop": 17,
        "contentBottom": 80,
        "contentLeft": 24,
        "contentRight": 74
      },
      "frontSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[1440, 0], [1344, 0], [1248, 0], [1152, 0], [1056, 0], [960, 0], [864, 0], [768, 0]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[768, 0], [864, 0], [960, 0], [1056, 0], [1152, 0], [1248, 0], [1344, 0], [1440, 0]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontHurt": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[576, 0], [672, 0], [768, 0], [864, 0]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[0, 0], [96, 0]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 167,
        "loop": true,
        "contentTop": 44,
        "contentBottom": 96,
        "contentLeft": 9,
        "contentRight": 57
      },
      "backSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[672, 0], [576, 0], [480, 0], [384, 0], [288, 0], [192, 0], [96, 0], [0, 0]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[0, 0], [96, 0], [192, 0], [288, 0], [384, 0], [480, 0], [576, 0], [672, 0]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "mini": {
        "spritesheetUrl": "/assets/mons/all/mon_mini.png",
        "frames": [[0, 0], [32, 0]],
        "frameWidth": 32,
        "frameHeight": 32,
        "frameDurationMs": 167,
        "loop": true
      },
      "micro": {
        "spritesheetUrl": "/assets/mons/all/mon_micro.png",
        "frames": [[0, 0], [16, 0]],
        "frameWidth": 16,
        "frameHeight": 16,
        "frameDurationMs": 167,
        "loop": true
      },
      "shadow": {
        "spritesheetUrl": "/assets/mons/all/mon_shadow.png",
        "frames": [[0, 0], [96, 0], [192, 0], [288, 0]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "cx": 48.5
      }
    },
    "stats": {
      "hp": 400,
      "attack": 150,
      "defense": 230,
      "specialAttack": 100,
      "specialDefense": 220,
      "speed": 100
    },
    "type1": Type.Metal,
    "type2": null,
    "moves": [
      {
        "address": Address.VOLATILE_PUNCH,
        "name": "Volatile Punch",
        "power": 40,
        "stamina": 3,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Metal,
        "class": MoveClass.Physical,
        "description": "Deals damage. 25% chance of Burn and 25% chance of Frostbite.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0
      },
      {
        "address": Address.GILDED_RECOVERY,
        "name": "Gilded Recovery",
        "power": 0,
        "stamina": 2,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Faith,
        "class": MoveClass.Self,
        "description": "Removes a status condition from a mon on your team. If successful, Aurox heals 50% of max HP and the target gains +1 stamina.",
        "inputType": "self-mon",
        "targetSpec": "none",
        "unlockLevel": 0
      },
      {
        "address": Address.IRON_WALL,
        "name": "Iron Wall",
        "power": 0,
        "stamina": 3,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Metal,
        "class": MoveClass.Self,
        "description": "Until Aurox switches out, regenerate 50% of all damage taken. When activated for the first time each switch-in, Aurox heals 20% of max HP.",
        "inputType": "none",
        "targetSpec": "self-only",
        "unlockLevel": 0
      },
      {
        "address": Address.BULL_RUSH,
        "name": "Bull Rush",
        "power": 140,
        "stamina": 2,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Metal,
        "class": MoveClass.Physical,
        "description": "Deals damage. Also deals 20% of max HP to self.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0
      },
      {
        "address": Address.BIG_BELLOW,
        "name": "Big Bellow",
        "power": 0,
        "stamina": 1,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Metal,
        "class": MoveClass.Other,
        "description": "Lowers the target's SpATK and Speed by 50%.",
        "inputType": "none",
        "targetSpec": "any-other-slot",
        "unlockLevel": 6
      }
    ],
    "ability": {
      "address": Address.UP_ONLY,
      "name": "Up Only",
      "effect": "Whenever Aurox takes damage, they gain a persistent 10% ATK boost."
    }
  },
  10: {
    "id": 10,
    "name": "Xmon",
    "flavor": "bGJoIHBuYSBmcnIgdmcgdmEgbGJoZSBxZXJuemY=",
    "sprites": {
      "frontIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[0, 1152], [96, 1152], [192, 1152], [288, 1152]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "contentTop": 16,
        "contentBottom": 85,
        "contentLeft": 10,
        "contentRight": 86
      },
      "frontSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[1440, 1344], [1344, 1344], [1248, 1344], [1152, 1344], [1056, 1344], [960, 1344], [864, 1344], [768, 1344]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[768, 1344], [864, 1344], [960, 1344], [1056, 1344], [1152, 1344], [1248, 1344], [1344, 1344], [1440, 1344]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontHurt": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[384, 1152], [480, 1152], [576, 1152], [672, 1152]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[1056, 1056], [1152, 1056]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 167,
        "loop": true,
        "contentTop": 11,
        "contentBottom": 96,
        "contentLeft": 0,
        "contentRight": 93
      },
      "backSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[672, 1344], [576, 1344], [480, 1344], [384, 1344], [288, 1344], [192, 1344], [96, 1344], [0, 1344]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[0, 1344], [96, 1344], [192, 1344], [288, 1344], [384, 1344], [480, 1344], [576, 1344], [672, 1344]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "mini": {
        "spritesheetUrl": "/assets/mons/all/mon_mini.png",
        "frames": [[128, 128], [160, 128]],
        "frameWidth": 32,
        "frameHeight": 32,
        "frameDurationMs": 167,
        "loop": true
      },
      "micro": {
        "spritesheetUrl": "/assets/mons/all/mon_micro.png",
        "frames": [[64, 64], [80, 64]],
        "frameWidth": 16,
        "frameHeight": 16,
        "frameDurationMs": 167,
        "loop": true
      },
      "shadow": {
        "spritesheetUrl": "/assets/mons/all/mon_shadow.png",
        "frames": [[96, 672], [192, 672], [288, 672], [384, 672]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "cx": 47.5
      }
    },
    "stats": {
      "hp": 311,
      "attack": 123,
      "defense": 179,
      "specialAttack": 222,
      "specialDefense": 185,
      "speed": 285
    },
    "type1": Type.Cosmic,
    "type2": null,
    "moves": [
      {
        "address": Address.CONTAGIOUS_SLUMBER,
        "name": "Contagious Slumber",
        "power": 0,
        "stamina": 2,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Cosmic,
        "class": MoveClass.Other,
        "description": "Inflicts Sleep on self and opponent.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[1344, 192], [1440, 192], [1536, 192], [1632, 192], [1728, 192], [1824, 192], [1920, 192], [2016, 192], [2112, 192], [2208, 192], [2304, 192], [2400, 192], [0, 288], [96, 288], [192, 288], [288, 288], [384, 288], [480, 288], [576, 288], [672, 288], [768, 288], [864, 288], [960, 288], [1056, 288]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      },
      {
        "address": Address.VITAL_SIPHON,
        "name": "Vital Siphon",
        "power": 40,
        "stamina": 2,
        "accuracy": 90,
        "priority": 0,
        "type": Type.Cosmic,
        "class": MoveClass.Special,
        "description": "Deals damage, 50% chance to steal 1 stamina from opponent.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[288, 2112], [384, 2112], [480, 2112], [576, 2112], [672, 2112], [768, 2112], [864, 2112], [960, 2112], [1056, 2112], [1152, 2112], [1248, 2112], [1344, 2112], [1440, 2112], [1536, 2112], [1632, 2112], [1728, 2112], [1824, 2112], [1920, 2112], [2016, 2112], [2112, 2112], [2208, 2112], [2304, 2112], [2400, 2112], [0, 2208]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      },
      {
        "address": Address.SOMNIPHOBIA,
        "name": "Somniphobia",
        "power": 0,
        "stamina": 1,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Cosmic,
        "class": MoveClass.Other,
        "description": "For 4 rounds, any opposing mon that gains stamina takes 12.5% of its max HP per stack as damage. Repeated casts while active increase the damage but do not reset the cooldown.",
        "inputType": "none",
        "targetSpec": "self-only",
        "unlockLevel": 0
      },
      {
        "address": Address.OLD_VENGEANCE,
        "name": "Old Vengeance",
        "power": 30,
        "stamina": 4,
        "accuracy": 100,
        "priority": 1,
        "type": Type.Cosmic,
        "class": MoveClass.Special,
        "description": "Deals damage first, then at end of turn deals damage again once per stamina the opponent spent this turn.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0
      },
      {
        "address": Address.INVOKE_TABOO,
        "name": "Invoke Taboo",
        "power": 0,
        "stamina": 1,
        "accuracy": 100,
        "priority": -1,
        "type": Type.Cosmic,
        "class": MoveClass.Other,
        "description": "Taboos the opponent's last used move. Until they switch out, if they use that move again they fall asleep.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 6
      }
    ],
    "ability": {
      "address": Address.DREAMCATCHER,
      "name": "Dreamcatcher",
      "effect": "Whenever Xmon gains stamina, heal 1/16 (6.25%) of max HP."
    }
  },
  11: {
    "id": 11,
    "name": "Ekineki",
    "flavor": "Born from a single drop of water.",
    "sprites": {
      "frontIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[96, 96], [192, 96], [288, 96], [384, 96]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "contentTop": 15,
        "contentBottom": 79,
        "contentLeft": 16,
        "contentRight": 80
      },
      "frontSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[1440, 96], [1344, 96], [1248, 96], [1152, 96], [1056, 96], [960, 96], [864, 96], [768, 96]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[768, 96], [864, 96], [960, 96], [1056, 96], [1152, 96], [1248, 96], [1344, 96], [1440, 96]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontHurt": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[480, 96], [576, 96], [672, 96], [768, 96]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[960, 0], [1056, 0], [1152, 0], [0, 96]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "contentTop": 16,
        "contentBottom": 96,
        "contentLeft": 0,
        "contentRight": 69
      },
      "backSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[672, 96], [576, 96], [480, 96], [384, 96], [288, 96], [192, 96], [96, 96], [0, 96]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[0, 96], [96, 96], [192, 96], [288, 96], [384, 96], [480, 96], [576, 96], [672, 96]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "mini": {
        "spritesheetUrl": "/assets/mons/all/mon_mini.png",
        "frames": [[64, 0], [96, 0]],
        "frameWidth": 32,
        "frameHeight": 32,
        "frameDurationMs": 167,
        "loop": true
      },
      "micro": {
        "spritesheetUrl": "/assets/mons/all/mon_micro.png",
        "frames": [[32, 0], [48, 0]],
        "frameWidth": 16,
        "frameHeight": 16,
        "frameDurationMs": 167,
        "loop": true
      },
      "shadow": {
        "spritesheetUrl": "/assets/mons/all/mon_shadow.png",
        "frames": [[384, 0], [480, 0], [576, 0], [672, 0]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "cx": 47.5
      }
    },
    "stats": {
      "hp": 299,
      "attack": 130,
      "defense": 180,
      "specialAttack": 280,
      "specialDefense": 175,
      "speed": 266
    },
    "type1": Type.Liquid,
    "type2": null,
    "moves": [
      {
        "address": Address.BUBBLE_BOP,
        "name": "Bubble Bop",
        "power": 50,
        "stamina": 3,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Liquid,
        "class": MoveClass.Special,
        "description": "Hits twice. Each hit deals 50 base power.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[2304, 0], [2400, 0], [0, 96], [96, 96], [192, 96], [288, 96], [384, 96], [480, 96], [576, 96], [672, 96], [768, 96], [864, 96], [960, 96], [1056, 96], [1152, 96], [1248, 96], [1344, 96], [1440, 96], [1536, 96], [1632, 96], [1728, 96], [1824, 96], [1920, 96], [2016, 96]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      },
      {
        "address": Address.SNEAK_ATTACK,
        "name": "Sneak Attack",
        "power": 70,
        "stamina": 2,
        "accuracy": 100,
        "priority": 1,
        "type": Type.Liquid,
        "class": MoveClass.Special,
        "description": "Hits any opponent mon (even non-active). Can only be used once per switch-in.",
        "inputType": "opponent-mon",
        "targetSpec": "none",
        "unlockLevel": 0,
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[864, 1728], [960, 1728], [1056, 1728], [1152, 1728], [1248, 1728], [1344, 1728], [1440, 1728], [1536, 1728], [1632, 1728], [1728, 1728], [1824, 1728], [1920, 1728], [2016, 1728], [2112, 1728], [2208, 1728], [2304, 1728], [2400, 1728], [0, 1824]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      },
      {
        "address": Address.NINE_NINE_NINE,
        "name": "Nine Nine Nine",
        "power": 0,
        "stamina": 1,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Math,
        "class": MoveClass.Self,
        "description": "Sets crit rate to 90% on the next turn for all moves.",
        "inputType": "none",
        "targetSpec": "self-only",
        "unlockLevel": 0
      },
      {
        "address": Address.OVERFLOW,
        "name": "Overflow",
        "power": 90,
        "stamina": 3,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Math,
        "class": MoveClass.Special,
        "description": "Deals damage.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0
      }
    ],
    "ability": {
      "address": Address.SAVIOR_COMPLEX,
      "name": "Savior Complex",
      "effect": "On switch-in, gain a temporary 15/25/30% SpATK boost based on KO'd mons (1/2/3+). Triggers once per game."
    }
  },
  12: {
    "id": 12,
    "name": "Nirvamma",
    "flavor": "Supposedly watches the entire universe.",
    "sprites": {
      "frontIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[768, 768], [864, 768], [960, 768], [1056, 768], [1152, 768], [0, 864], [96, 864], [192, 864]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "contentTop": 1,
        "contentBottom": 93,
        "contentLeft": 20,
        "contentRight": 79
      },
      "frontSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[1440, 960], [1344, 960], [1248, 960], [1152, 960], [1056, 960], [960, 960], [864, 960], [768, 960]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[768, 960], [864, 960], [960, 960], [1056, 960], [1152, 960], [1248, 960], [1344, 960], [1440, 960]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontHurt": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[288, 864], [384, 864], [480, 864], [576, 864]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[576, 768], [672, 768]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "contentTop": 1,
        "contentBottom": 96,
        "contentLeft": 0,
        "contentRight": 65
      },
      "backSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[672, 960], [576, 960], [480, 960], [384, 960], [288, 960], [192, 960], [96, 960], [0, 960]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[0, 960], [96, 960], [192, 960], [288, 960], [384, 960], [480, 960], [576, 960], [672, 960]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "mini": {
        "spritesheetUrl": "/assets/mons/all/mon_mini.png",
        "frames": [[64, 96], [96, 96]],
        "frameWidth": 32,
        "frameHeight": 32,
        "frameDurationMs": 167,
        "loop": true
      },
      "micro": {
        "spritesheetUrl": "/assets/mons/all/mon_micro.png",
        "frames": [[32, 48], [48, 48]],
        "frameWidth": 16,
        "frameHeight": 16,
        "frameDurationMs": 167,
        "loop": true
      },
      "shadow": {
        "spritesheetUrl": "/assets/mons/all/mon_shadow.png",
        "frames": [[768, 384], [0, 480], [96, 480], [192, 480], [288, 480], [384, 480], [480, 480], [576, 480]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "cx": 49.0
      }
    },
    "stats": {
      "hp": 373,
      "attack": 202,
      "defense": 168,
      "specialAttack": 140,
      "specialDefense": 202,
      "speed": 177
    },
    "type1": Type.Math,
    "type2": null,
    "moves": [
      {
        "address": Address.HARD_RESET,
        "name": "Hard Reset",
        "power": 0,
        "stamina": 2,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Math,
        "class": MoveClass.Other,
        "description": "The next time your team rests, the resting mon gains +1 stamina, heals 12.5% max HP, and is swapped out. The next time your opponent rests, their mon loses 1 stamina, takes 12.5% max HP damage, and also swaps out.",
        "inputType": "none",
        "targetSpec": "none",
        "unlockLevel": 0
      },
      {
        "address": Address.SCARY_NUMBERS,
        "name": "Scary Numbers",
        "power": 80,
        "stamina": 3,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Math,
        "class": MoveClass.Physical,
        "description": "Deals damage, 20% chance to inflict Panic.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "inlineKey": "0x500b31400000000000000000",
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[2016, 1536], [2112, 1536], [2208, 1536], [2304, 1536], [2400, 1536], [0, 1632], [96, 1632], [192, 1632], [288, 1632], [384, 1632], [480, 1632], [576, 1632], [672, 1632], [768, 1632], [864, 1632], [960, 1632], [1056, 1632], [1152, 1632], [1248, 1632], [1344, 1632], [1440, 1632], [1536, 1632], [1632, 1632], [1728, 1632]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      },
      {
        "address": Address.CHRONOFFENSE,
        "name": "Chronoffense",
        "power": "?",
        "stamina": 2,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Math,
        "class": MoveClass.Physical,
        "description": "First use boosts defenses. Second use deals damage based on how much time has passed, and then resets.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0
      },
      {
        "address": Address.MODAL_BOLT,
        "name": "Modal Bolt",
        "power": 90,
        "stamina": 3,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Math,
        "class": MoveClass.Physical,
        "description": "Choose between Fire, Ice, or Lightning each use. Each mode is usable once, and applies its corresponding status (Burn / Frostbite / Zap) at 50% chance.",
        "inputType": "mode-select",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "sprite": {
          "fire": {
            "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
            "frames": [[2304, 960], [2400, 960], [0, 1056], [96, 1056], [192, 1056], [288, 1056], [384, 1056], [480, 1056], [576, 1056], [672, 1056], [768, 1056], [864, 1056], [960, 1056], [1056, 1056], [1152, 1056], [1248, 1056]],
            "frameWidth": 96,
            "frameHeight": 96,
            "frameDurationMs": 83,
            "loop": false
          },
          "ice": {
            "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
            "frames": [[1344, 1056], [1440, 1056], [1536, 1056], [1632, 1056], [1728, 1056], [1824, 1056], [1920, 1056], [2016, 1056], [2112, 1056], [2208, 1056], [2304, 1056], [2400, 1056], [0, 1152], [96, 1152], [192, 1152], [288, 1152]],
            "frameWidth": 96,
            "frameHeight": 96,
            "frameDurationMs": 83,
            "loop": false
          },
          "lightning": {
            "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
            "frames": [[384, 1152], [480, 1152], [576, 1152], [672, 1152], [768, 1152], [864, 1152], [960, 1152], [1056, 1152], [1152, 1152], [1248, 1152], [1344, 1152], [1440, 1152], [1536, 1152], [1632, 1152], [1728, 1152], [1824, 1152]],
            "frameWidth": 96,
            "frameHeight": 96,
            "frameDurationMs": 83,
            "loop": false
          }
        }
      }
    ],
    "ability": {
      "address": Address.ADAPTOR,
      "name": "Adaptor",
      "effect": "When Nirvamma takes damage for the first time each game, they adapt to that source of damage. Nirvamma take 50% less damage from that move or effect."
    }
  },
  13: {
    "id": 13,
    "name": "Glob",
    "flavor": "A very hardy creature. Found everywhere.",
    "sprites": {
      "frontIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[672, 288], [768, 288], [864, 288], [960, 288]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "contentTop": 15,
        "contentBottom": 81,
        "contentLeft": 12,
        "contentRight": 82
      },
      "frontSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[1440, 384], [1344, 384], [1248, 384], [1152, 384], [1056, 384], [960, 384], [864, 384], [768, 384]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[768, 384], [864, 384], [960, 384], [1056, 384], [1152, 384], [1248, 384], [1344, 384], [1440, 384]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontHurt": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[1056, 288], [1152, 288], [0, 384], [96, 384]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[288, 288], [384, 288], [480, 288], [576, 288]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 167,
        "loop": true,
        "contentTop": 21,
        "contentBottom": 96,
        "contentLeft": 0,
        "contentRight": 84
      },
      "backSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[672, 384], [576, 384], [480, 384], [384, 384], [288, 384], [192, 384], [96, 384], [0, 384]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[0, 384], [96, 384], [192, 384], [288, 384], [384, 384], [480, 384], [576, 384], [672, 384]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "mini": {
        "spritesheetUrl": "/assets/mons/all/mon_mini.png",
        "frames": [[64, 32], [96, 32]],
        "frameWidth": 32,
        "frameHeight": 32,
        "frameDurationMs": 167,
        "loop": true
      },
      "micro": {
        "spritesheetUrl": "/assets/mons/all/mon_micro.png",
        "frames": [[32, 16], [48, 16]],
        "frameWidth": 16,
        "frameHeight": 16,
        "frameDurationMs": 167,
        "loop": true
      },
      "shadow": {
        "spritesheetUrl": "/assets/mons/all/mon_shadow.png",
        "frames": [[672, 96], [768, 96], [0, 192], [96, 192]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "cx": 47.5
      }
    },
    "stats": {
      "hp": 256,
      "attack": 180,
      "defense": 201,
      "specialAttack": 115,
      "specialDefense": 191,
      "speed": 151
    },
    "type1": Type.Liquid,
    "type2": Type.Faith,
    "moves": [
      {
        "address": Address.HOLY_MOLT,
        "name": "Holy Molt",
        "power": 0,
        "stamina": "?",
        "accuracy": 100,
        "priority": 1,
        "type": Type.Faith,
        "class": MoveClass.Self,
        "description": "Spend half of current health to apply Bless to self. Stamina cost goes up per use, to a max of 3%.",
        "inputType": "none",
        "targetSpec": "self-only",
        "unlockLevel": 0,
        "overlayPlacement": "self",
        "sprite": {
          "spritesheetUrl": "/assets/attacks/attack_spritesheet.png",
          "frames": [[384, 576], [480, 576], [576, 576], [672, 576], [768, 576], [864, 576], [960, 576], [1056, 576], [1152, 576], [1248, 576], [1344, 576], [1440, 576], [1536, 576], [1632, 576], [1728, 576], [1824, 576]],
          "frameWidth": 96,
          "frameHeight": 96,
          "frameDurationMs": 83,
          "loop": false
        }
      },
      {
        "address": Address.WATER_CLAW,
        "name": "Water Claw",
        "power": 80,
        "stamina": 2,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Liquid,
        "class": MoveClass.Physical,
        "description": "Deals damage.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "inlineKey": "0x500320000000000000000000"
      },
      {
        "address": Address.HOLY_WATER_CLAW,
        "name": "Holy Water Claw",
        "power": 90,
        "stamina": 3,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Faith,
        "class": MoveClass.Physical,
        "description": "Deals damage.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "inlineKey": "0x5a0930000000000000000000"
      },
      {
        "address": Address.GET_SLIPPERY,
        "name": "Get Slippery",
        "power": 0,
        "stamina": 2,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Liquid,
        "class": MoveClass.Self,
        "description": "Boosts ATK and Speed by 50%.",
        "inputType": "none",
        "targetSpec": "self-only",
        "unlockLevel": 0
      }
    ],
    "ability": {
      "address": Address.CHOSEN_ONE,
      "name": "Chosen One",
      "effect": "Glob starts each game Blessed when it switches in."
    }
  },
  14: {
    "id": 14,
    "name": "Mulong",
    "flavor": "One of the Cardinal Beasts.",
    "sprites": {
      "frontIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[672, 672], [768, 672], [864, 672], [960, 672], [1056, 672], [1152, 672], [0, 768], [96, 768]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "contentTop": 8,
        "contentBottom": 86,
        "contentLeft": 2,
        "contentRight": 90
      },
      "frontSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[1440, 864], [1344, 864], [1248, 864], [1152, 864], [1056, 864], [960, 864], [864, 864], [768, 864]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[768, 864], [864, 864], [960, 864], [1056, 864], [1152, 864], [1248, 864], [1344, 864], [1440, 864]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "frontHurt": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[192, 768], [288, 768], [384, 768], [480, 768]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backIdle": {
        "spritesheetUrl": "/assets/mons/all/mon_spritesheet.png",
        "frames": [[288, 672], [384, 672], [480, 672], [576, 672]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 167,
        "loop": true,
        "contentTop": 10,
        "contentBottom": 96,
        "contentLeft": 0,
        "contentRight": 96
      },
      "backSwitchIn": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[672, 864], [576, 864], [480, 864], [384, 864], [288, 864], [192, 864], [96, 864], [0, 864]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "backSwitchOut": {
        "spritesheetUrl": "/assets/mons/all/mon_switch.png",
        "frames": [[0, 864], [96, 864], [192, 864], [288, 864], [384, 864], [480, 864], [576, 864], [672, 864]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": false
      },
      "mini": {
        "spritesheetUrl": "/assets/mons/all/mon_mini.png",
        "frames": [[0, 96], [32, 96]],
        "frameWidth": 32,
        "frameHeight": 32,
        "frameDurationMs": 167,
        "loop": true
      },
      "micro": {
        "spritesheetUrl": "/assets/mons/all/mon_micro.png",
        "frames": [[0, 48], [16, 48]],
        "frameWidth": 16,
        "frameHeight": 16,
        "frameDurationMs": 167,
        "loop": true
      },
      "shadow": {
        "spritesheetUrl": "/assets/mons/all/mon_shadow.png",
        "frames": [[0, 384], [96, 384], [192, 384], [288, 384], [384, 384], [480, 384], [576, 384], [672, 384]],
        "frameWidth": 96,
        "frameHeight": 96,
        "frameDurationMs": 83,
        "loop": true,
        "cx": 46.5
      }
    },
    "stats": {
      "hp": 388,
      "attack": 115,
      "defense": 188,
      "specialAttack": 288,
      "specialDefense": 138,
      "speed": 212
    },
    "type1": Type.Air,
    "type2": Type.Lightning,
    "moves": [
      {
        "address": Address.SUMMON_STORM,
        "name": "Summon Storm",
        "power": 0,
        "stamina": 4,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Lightning,
        "class": MoveClass.Other,
        "description": "Summons a Storm for 5 turns that damages all active mons.",
        "inputType": "none",
        "targetSpec": "none",
        "unlockLevel": 0
      },
      {
        "address": Address.GRAND_RESPITE,
        "name": "Grand Respite",
        "power": 120,
        "stamina": 2,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Air,
        "class": MoveClass.Special,
        "description": "The next time Mulong rests, it deals damage to the target.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0
      },
      {
        "address": Address.THUNDERCLAP,
        "name": "Thunderclap",
        "power": 120,
        "stamina": 3,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Lightning,
        "class": MoveClass.Special,
        "description": "Deals damage, 20% chance to inflict Zap.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0,
        "inlineKey": "0x784831400000000000000000"
      },
      {
        "address": Address.CLOUD_STRIKE,
        "name": "Cloud Strike",
        "power": "?",
        "stamina": 2,
        "accuracy": 100,
        "priority": 0,
        "type": Type.Ice,
        "class": MoveClass.Special,
        "description": "Deals damage, 10% chance to inflict Frostbite. While Storm is active, power rises to 100% and Frostbite chance to 30%.",
        "inputType": "none",
        "targetSpec": "opponent-slot",
        "unlockLevel": 0
      }
    ],
    "ability": {
      "address": Address.KINGS_LEISURE,
      "name": "King's Leisure",
      "effect": "Mulong takes half damage and deals half damage for the first 3 turns it arrives."
    }
  }
} as const;

// Moves that fan out to more than one attack animation emit this open map on
// `sprite` instead of a single SpriteAnimationConfig; the renderer picks the
// key by branch (the move's MoveBranch). Each variant move owns its own keys —
// Gachachacha uses runtime outcomes (normal/oppKO/selfKO), Modal Bolt uses the
// cast-time mode (fire/ice/lightning) — so nothing central enumerates them.
export type MoveSpriteVariants = {
  readonly [variant: string]: SpriteAnimationConfig;
};

// Where a move's attack overlay renders. Default 'target' overlays the sprite
// on the opposing mon; 'canvas-center' lifts it to the middle of the battle
// canvas and 'canvas-full' spans the whole field (both work across
// desktop/mobile/large without per-breakpoint coords).
export type AttackOverlayPlacement = 'target' | 'canvas-center' | 'canvas-full' | 'self';

export type Move = {
  readonly address: LowercaseHex;
  readonly name: string;
  readonly power: number | '?';
  readonly stamina: number | '?';
  readonly accuracy: number | '?';
  readonly priority: number | '?';
  readonly type: Type;
  readonly class: MoveClass;
  readonly description: string;
  // Battle-context description with live {token}s left raw for MoveDynamic resolvers to fill
  // (static tokens are pre-baked). Absent when the move has no dynamic display value.
  readonly descriptionTemplate?: string;
  readonly inputType: MoveInputType;
  readonly targetSpec: MoveTargetSpec;
  // Level a player's mon must reach before this move can be brought into battle. 0 = always
  // available (battle lanes 0..3); higher-lane moves unlock at 6 (see MonExp._unlockLevelForLane).
  readonly unlockLevel: number;
  // Effect-address-independent identity for inline (JSON) moves: the upper 96 bits of the packed
  // move word. Lets a frozen on-chain battle move resolve to this catalog entry. Absent for
  // deployed moves (those resolve by `address`).
  readonly inlineKey?: string;
  readonly sprite?: SpriteAnimationConfig | MoveSpriteVariants;
  // Narrower sheet for the mobile field (4:3), where `sprite` is drawn for desktop's 2:1.
  // Only full-field overlays need one; everything else reads fine from a single sheet.
  readonly spriteMobile?: SpriteAnimationConfig;
  readonly overlayPlacement?: AttackOverlayPlacement;
};

export type Mon = {
  readonly id: number;
  readonly name: string;
  readonly flavor: string;
  readonly sprites: {
    readonly frontIdle: SpriteAnimationConfig;
    readonly frontSwitchIn: SpriteAnimationConfig;
    readonly frontSwitchOut: SpriteAnimationConfig;
    readonly frontHurt?: SpriteAnimationConfig;
    readonly backIdle: SpriteAnimationConfig;
    readonly backSwitchIn: SpriteAnimationConfig;
    readonly backSwitchOut: SpriteAnimationConfig;
    readonly backHurt?: SpriteAnimationConfig;
    readonly mini: SpriteAnimationConfig;
    readonly micro?: SpriteAnimationConfig;
    readonly shadow?: SpriteAnimationConfig;
  };
  readonly stats: {
    readonly hp: number;
    readonly attack: number;
    readonly defense: number;
    readonly specialAttack: number;
    readonly specialDefense: number;
    readonly speed: number;
  };
  readonly type1: Type;
  readonly type2: Type | null;
  readonly moves: readonly [Move, Move, Move, Move, ...Array<Move>];
  readonly ability: {
    readonly address: LowercaseHex;
    readonly name: string;
    readonly effect: string;
  };
};

export type MonDatabase = Record<number, Mon>;

export interface MonStatMatch {
  readonly mon: Mon;
  readonly facetId: number; // 0 = no facet, 1..12 = facet id (mirrors Facets.sol)
}

// Pre-baked with all 13 variants per mon (no-facet + facets 1..12) so a
// Facet'd mon's on-chain stats hit directly.
export const monStatLookup = new Map<string, MonStatMatch>();

export function getMonStatsKey(stats: { hp: number; attack: number; defense: number; specialAttack: number; specialDefense: number; speed: number }): string {
  return `${stats.hp}-${stats.attack}-${stats.defense}-${stats.specialAttack}-${stats.specialDefense}-${stats.speed}`;
}

for (const mon of Object.values(MonMetadata)) {
  monStatLookup.set(getMonStatsKey(mon.stats), { mon, facetId: 0 });
  for (let facetId = 1; facetId <= TOTAL_FACETS; facetId++) {
    const key = getMonStatsKey(applyFacetToStats(mon.stats, facetId));
    // No-facet variant always wins on collision (it's inserted first); among
    // facet variants, first writer wins — chain is the source of truth.
    if (!monStatLookup.has(key)) {
      monStatLookup.set(key, { mon, facetId });
    }
  }
}

// Pre-computed max stats across all mons
export const MAX_MON_STATS: Record<keyof Mon['stats'], number> = {
  hp: 0,
  attack: 0,
  defense: 0,
  specialAttack: 0,
  specialDefense: 0,
  speed: 0,
};

for (const monData of Object.values(MonMetadata)) {
  const stats = monData.stats;
  for (const statName of Object.keys(stats) as (keyof typeof stats)[]) {
    if (stats[statName] > MAX_MON_STATS[statName]) {
      MAX_MON_STATS[statName] = stats[statName];
    }
  }
}
